// ENERGIE Cart API — event delegation
if (window.__energieCartLoaded) { /* avoid double listener attach */ } else {
window.__energieCartLoaded = true;

// Todas las escrituras propias del carrito pasan por esta cola. El mini
// carrito toma la misma cola para mantener su snapshot y verificación final
// como una única sección crítica frente a los adds delegados del tema.
// Esto no hace atómicos actores externos: el mini verifica antes de cada
// cantidad absoluta y se detiene ante cualquier divergencia observable.
window.EnergieCartMutations = window.EnergieCartMutations || (function () {
  var tail = Promise.resolve();
  return {
    run: function (task) {
      var next = tail.then(task, task);
      tail = next.catch(function () {});
      return next;
    }
  };
}());
function encolarMutacionCarrito(task) {
  return window.EnergieCartMutations.run(task);
}

// Cantidad elegida en el selector, que `initQtySelectors()` (snippets/premium-effects.liquid)
// escribe como `data-quantity` en todo botón con el `data-qty-target` de ese selector.
// Un botón sin `data-qty-target` nunca la recibe y se queda en 1, que es lo correcto para
// los CTA sueltos como los del popup de bienvenida.
function leerCantidad(btn) {
  var q = parseInt(btn.getAttribute('data-quantity') || '1', 10);
  if (isNaN(q) || q < 1) return 1;
  return q > 99 ? 99 : q;
}

// Los CTA de PDP pueden tener una etiqueta interna (por ejemplo, el selector
// Omega A/B). Cambiar el texto del botón completo borraría esa estructura y
// rompería la actualización de la opción elegida. Los CTA legados conservan
// el botón como etiqueta.
function etiquetaBoton(btn) {
  return btn.querySelector('[data-omega-label]') || btn;
}
function leerEtiquetaBoton(btn) {
  return etiquetaBoton(btn).textContent;
}
function escribirEtiquetaBoton(btn, text) {
  etiquetaBoton(btn).textContent = text;
}
function sigueSeleccion(btn, request) {
  return btn.getAttribute('data-action') === request.action &&
    (!request.handle || btn.getAttribute('data-product-handle') === request.handle) &&
    (!request.selection || btn.getAttribute('data-omega-selection') === request.selection);
}

function updateCartBadge() {
  return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    document.querySelectorAll('.en-cart-count').forEach(function(b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    return cart;
  });
}
// El smart event AddToCart de Clarity infiere el add a partir del CLIC, y llega
// subcontado: 3 eventos en 3 días cuando en las grabaciones se ve a la gente
// tocando "Agregar al carrito" muchas más veces. Un clic no es un add — puede
// rebotar en una capa, o el POST puede fallar en el webview de Instagram.
// Este evento se emite solo cuando Shopify ya respondió OK, así que cuenta
// productos agregados de verdad. Se dispara en las tres rutas de add del theme.
function marcaAddToCartClarity() {
  try { if (window.clarity) window.clarity('event', 'AddToCart'); } catch (e) {}
}
function dispatchCartUpdate(cart, added) {
  // Free-shipping-toast (assets/free-shipping-toast.js) y otros listeners suben de aquí.
  // Sin este dispatch el toast post-add nunca aparece — bug histórico que dejaba al user mobile
  // sin feedback visible tras "Agregar al carrito".
  document.dispatchEvent(new CustomEvent('cart:update', {
    detail: { resource: cart, data: { itemCount: cart.item_count, source: 'energie-cart', added: added } }
  }));
}
// La selección puede cambiar mientras Shopify responde. El mini carrito debe
// describir exactamente el add que se confirmó, no el estado posterior del CTA.
function capturaAdd(btn, quantity, handle, variantId) {
  var flavor = document.querySelector('.variant-btn.active[data-flavor]');
  return {
    variantId: parseInt(variantId || btn.getAttribute('data-variant'), 10) || null,
    requestedQty: quantity,
    handle: handle || btn.getAttribute('data-product-handle') || '',
    flavor: flavor && flavor.getAttribute('data-flavor') || '',
    destination: window.location.pathname
  };
}
function detalleAgregado(item, captured, cart) {
  item = item || {};
  var confirmed = cart && (cart.items || []).find(function(line) { return line.key === item.key; }) || item;
  return {
    key: item.key || '',
    requestedQty: captured.requestedQty,
    handle: confirmed.handle || confirmed.product_handle || captured.handle,
    flavor: captured.flavor,
    destination: captured.destination,
    title: confirmed.product_title || confirmed.title || '',
    image: confirmed.image || confirmed.featured_image && confirmed.featured_image.url || ''
  };
}
// Helper único de add-to-cart: valida HTTP (r.ok), parsea JSON seguro y RECHAZA si Shopify
// responde 4xx/5xx (sold out, variante inválida) o si la red falla (webview IG/FB).
// Antes varios handlers asumían éxito sin chequear r.ok → falso "✓ Agregado" o redirect a
// /checkout con el item NO agregado. Bug detectado vía Clarity (funnel 470 sesiones → 1 compra).
function cartAddJSON(body) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }).then(function(r) {
    return r.json().then(function(data) {
      if (!r.ok) throw new Error((data && (data.description || data.message)) || ('HTTP ' + r.status));
      marcaAddToCartClarity();
      return data;
    });
  });
}
// On page load: solo sync badge, NO dispatch (evita toast falso al cargar página con cart de
// sesión previa). Dispatch solo después de un add real.
updateCartBadge();

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="add"]');
  if (!btn) return;
  e.preventDefault();
  var variantId = btn.getAttribute('data-variant');
  // Lee data-quantity del bot\u00f3n (sincronizado por qty-selector via data-qty-target).
  // Fallback a 1 si no hay qty-selector ligado (compat con landing-home product cards).
  var quantity = parseInt(btn.getAttribute('data-quantity') || '1', 10);
  if (isNaN(quantity) || quantity < 1) quantity = 1;
  if (quantity > 99) quantity = 99;
  // El contexto es inmutable desde el clic. La tarea de la cola no vuelve a
  // consultar el CTA: el selector puede cambiar mientras otra mutación espera.
  var addedContext = capturaAdd(btn, quantity);
  var request = { action: btn.getAttribute('data-action'), selection: btn.getAttribute('data-omega-selection'), originalLabel: leerEtiquetaBoton(btn) };
  escribirEtiquetaBoton(btn, 'Agregando...');
  btn.style.opacity = '0.7';
  btn.style.pointerEvents = 'none';
  encolarMutacionCarrito(function () { return cartAddJSON({ id: addedContext.variantId, quantity: addedContext.requestedQty }).then(function(addedItem) {
    if (sigueSeleccion(btn, request)) escribirEtiquetaBoton(btn, '\u2713 \u00a1Agregado!');
    return updateCartBadge().then(function(cart) { dispatchCartUpdate(cart, detalleAgregado(addedItem, addedContext, cart)); });
  }); }).then(function() {
    setTimeout(function() {
      if (sigueSeleccion(btn, request)) escribirEtiquetaBoton(btn, request.originalLabel);
      btn.style.opacity = '1'; btn.style.pointerEvents = 'auto';
    }, 2000);
  }).catch(function() {
    // Ahora un 4xx (sold out / variante inv\u00e1lida) cae aqu\u00ed en vez de mostrar falso "\u2713 \u00a1Agregado!".
    if (sigueSeleccion(btn, request)) escribirEtiquetaBoton(btn, 'Error'); btn.style.opacity = '1'; btn.style.pointerEvents = 'auto';
    setTimeout(function() {
      if (sigueSeleccion(btn, request)) escribirEtiquetaBoton(btn, request.originalLabel);
    }, 2000);
  });
});

// Pack add — resolves default variant from product handle, then adds to cart
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="add-pack"]');
  if (!btn) return;
  e.preventDefault();
  var handle = btn.getAttribute('data-product-handle');
  if (!handle) return;
  var request = {
    handle: handle,
    quantity: leerCantidad(btn),
    action: btn.getAttribute('data-action'),
    selection: btn.getAttribute('data-omega-selection'),
    originalLabel: leerEtiquetaBoton(btn)
  };
  var addedContext = capturaAdd(btn, request.quantity, request.handle);
  escribirEtiquetaBoton(btn, 'Agregando pack...');
  btn.style.opacity = '0.7';
  btn.style.pointerEvents = 'none';

  fetch('/products/' + request.handle + '.js')
    .then(function(r) {
      if (!r.ok) throw new Error('Producto no encontrado: /products/' + handle + '.js (' + r.status + ')');
      return r.json();
    })
    .then(function(product) {
      var variant = product.variants && product.variants.find(function(item) { return item.available; });
      var variantId = variant && variant.id;
      if (!variantId) throw new Error('Sin variante disponible para handle: ' + request.handle);
      return encolarMutacionCarrito(function () { return cartAddJSON({ id: variantId, quantity: request.quantity }).then(function (addedItem) {
        return updateCartBadge().then(function(cart) { dispatchCartUpdate(cart, detalleAgregado(addedItem, addedContext, cart)); });
      }); });
    })
    .then(function() {
      if (sigueSeleccion(btn, request)) escribirEtiquetaBoton(btn, '\u2713 \u00a1Pack agregado!');
      setTimeout(function() {
        if (sigueSeleccion(btn, request)) {
          escribirEtiquetaBoton(btn, request.originalLabel);
        }
        btn.style.opacity = '1'; btn.style.pointerEvents = 'auto';
      }, 2000);
    })
    .catch(function(err) {
      console.error('[add-pack]', err);
      if (sigueSeleccion(btn, request)) escribirEtiquetaBoton(btn, 'Error'); btn.style.opacity = '1'; btn.style.pointerEvents = 'auto';
      setTimeout(function() {
        if (sigueSeleccion(btn, request)) {
          escribirEtiquetaBoton(btn, request.originalLabel);
        }
      }, 2000);
    });
});

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="buy"]');
  if (!btn) return;
  e.preventDefault();
  var originalText = btn.textContent;
  // "Comprar ahora" comparte el mismo contrato que add: nunca leer la
  // selección dentro de la tarea encolada.
  var request = capturaAdd(btn, leerCantidad(btn));
  if (!request.variantId) return;
  btn.textContent = 'Redirigiendo...';
  btn.style.pointerEvents = 'none';
  // Solo redirige a /checkout DESPUÉS de confirmar que el item entró al carrito.
  // Antes redirigía sin validar y sin catch → en webview IG/FB con red inestable dejaba el
  // botón muerto en "Redirigiendo..." o mandaba a /checkout con el carrito vacío.
  // La cantidad se lee igual que en [data-action="add"]: estaba fija en 1, así que quien
  // elegía 3 en el selector y tocaba "Comprar ahora" llegaba al checkout con una pieza.
  encolarMutacionCarrito(function () { return cartAddJSON({ id: request.variantId, quantity: request.requestedQty }); })
    .then(function() { window.location.href = '/checkout'; })
    .catch(function() {
      btn.textContent = 'Error'; btn.style.pointerEvents = 'auto';
      setTimeout(function() { btn.textContent = originalText; }, 2000);
    });
});

// Smart-buy (header/announce CTA en PDPs): si cart tiene items -> /checkout,
// si está vacío -> smooth-scroll offset-aware al anchor (default '#comprar').
// preventDefault + stopImmediatePropagation SÍNCRONO (Safari iOS no respeta
// preventDefault dentro de un .then async, y el smooth-scroll local de las PDPs
// también escucha clicks en a[href^="#"] — sin stopImmediate haría doble scroll).
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="smart-buy"]');
  if (!btn) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  var anchor = btn.getAttribute('data-anchor') || '#comprar';

  function scrollOrNavigate() {
    var target = document.querySelector(anchor);
    if (target) {
      var navEl = document.getElementById('en-nav');
      // 36 = alto del announce bar fijo; navEl.offsetHeight cubre el header.
      var navHeight = navEl ? navEl.offsetHeight + 36 : 100;
      var top = target.getBoundingClientRect().top + window.scrollY - navHeight;
      window.scrollTo({ top: top, behavior: 'smooth' });
      return;
    }
    // No hay anchor local en esta página (ej. pages estáticas con
    // href="/#productos"): seguir el href del <a> manualmente, porque
    // preventDefault síncrono ya canceló la navegación natural.
    var fallbackHref = btn.getAttribute('href');
    if (fallbackHref && fallbackHref !== '#') window.location.href = fallbackHref;
  }

  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    if (cart.item_count > 0) {
      window.location.href = '/checkout';
    } else {
      scrollOrNavigate();
    }
  }).catch(function() { scrollOrNavigate(); });
}, true);

// Buy-multi: agrega varios variants en un solo POST y redirige a /checkout.
// Uso: <a href="/cart/ID1:1,ID2:1" data-action="buy-multi" data-variants="ID1,ID2">.
// El href es fallback funcional si JS no carga (cart permalink Shopify).
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="buy-multi"]');
  if (!btn) return;
  e.preventDefault();
  var raw = btn.getAttribute('data-variants') || '';
  var items = raw.split(',').map(function(v) { return parseInt(v.trim(), 10); })
                 .filter(function(id) { return !isNaN(id) && id > 0; })
                 .map(function(id) { return { id: id, quantity: 1 }; });
  if (!items.length) return;
  var originalText = btn.textContent;
  btn.textContent = 'Redirigiendo...';
  btn.style.opacity = '0.7';
  btn.style.pointerEvents = 'none';
  encolarMutacionCarrito(function () { return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function(r) { return r.json().then(function(data) {
    if (!r.ok) throw new Error(data.description || data.message || ('HTTP ' + r.status));
    marcaAddToCartClarity();
    return data;
  }); }); }).then(function(data) {
    // GA4/GTM add_to_cart push (paridad con los otros [data-action="add"]).
    var added = data.items || (data.id ? [data] : []);
    if (window.dataLayer && added.length) {
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MXN',
          items: added.map(function(it) {
            return {
              item_id: String(it.variant_id || it.id),
              item_name: it.product_title || it.title || '',
              price: (it.price || 0) / 100,
              quantity: it.quantity || 1
            };
          })
        }
      });
    }
    updateCartBadge().then(dispatchCartUpdate).catch(function() {});
    window.location.href = '/checkout';
  }).catch(function(err) {
    console.error('[buy-multi]', err);
    btn.textContent = 'Error'; btn.style.opacity = '1'; btn.style.pointerEvents = 'auto';
    setTimeout(function() { btn.textContent = originalText; }, 2000);
  });
});

// Buy pack — resolver handle, add primer variant, redirect checkout
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="buy-pack"]');
  if (!btn) return;
  e.preventDefault();
  var request = {
    action: btn.getAttribute('data-action'),
    handle: btn.getAttribute('data-product-handle'),
    selection: btn.getAttribute('data-omega-selection'),
    quantity: leerCantidad(btn),
    originalLabel: leerEtiquetaBoton(btn)
  };
  if (!request.handle) return;
  escribirEtiquetaBoton(btn, 'Redirigiendo...');
  btn.style.pointerEvents = 'none';
  fetch('/products/' + request.handle + '.js')
    .then(function(r) {
      if (!r.ok) throw new Error('Producto no encontrado: ' + request.handle + ' (' + r.status + ')');
      return r.json();
    })
    .then(function(p) {
      var variant = p.variants && p.variants.find(function(item) { return item.available; });
      if (!variant) throw new Error('no variant');
      // valida r.ok del add antes de redirigir (vía helper) — antes redirigía sin confirmar.
      // La cantidad se lee igual que en [data-action="add-pack"], que ya la respetaba.
      return encolarMutacionCarrito(function () { return cartAddJSON({ id: variant.id, quantity: request.quantity }); });
    })
    .then(function() { window.location.href = '/checkout'; })
    .catch(function() {
      if (sigueSeleccion(btn, request)) escribirEtiquetaBoton(btn, 'Error');
      btn.style.pointerEvents = 'auto';
      setTimeout(function() { if (sigueSeleccion(btn, request)) escribirEtiquetaBoton(btn, request.originalLabel); }, 2000);
    });
});

// Flavor selector (for Hidra+)
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.variant-btn[data-flavor]');
  // `disabled` corta el clic nativo, pero no un evento sintetico: el sabor agotado no debe
  // poder activarse por ninguna via.
  if (!btn || btn.disabled) return;
  document.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  var newVariant = btn.getAttribute('data-flavor');
  document.querySelectorAll('.cta-row [data-action="add"]').forEach(function(b) {
    b.setAttribute('data-variant', newVariant);
  });
  document.querySelectorAll('.cta-row [data-action="buy"]').forEach(function(b) {
    b.setAttribute('data-variant', newVariant);
  });
  var ctaFinal = document.querySelector('.cta-final [data-action="add"]');
  if (ctaFinal) ctaFinal.setAttribute('data-variant', newVariant);
  var ctaFinalBuy = document.querySelector('.cta-final [data-action="buy"]');
  if (ctaFinalBuy) ctaFinalBuy.setAttribute('data-variant', newVariant);
  // La barra de compra fija tambien vende, y en movil es el boton mas usado:
  // sin esto se queda con el variant con el que nacio y agrega el sabor que el
  // cliente NO eligio. Se listan los contenedores uno por uno a proposito; un
  // querySelectorAll('[data-action="add"]') a secas tambien reescribiria los
  // botones de upsell y cross-sell de otros productos de la misma pagina.
  document.querySelectorAll('.pdp-sticky-cta [data-action="add"], .pdp-sticky-cta [data-action="buy"]').forEach(function(b) {
    b.setAttribute('data-variant', newVariant);
  });
});

// Rescate de los botones al volver desde el checkout (back/forward cache).
//
// Todos los handlers de compra dejan el boton en estado de carga: texto
// "Agregando..." o "Cargando checkout...", opacity 0.7 y pointer-events none. Los
// de checkout del carrito (resumen y barra fija) ademas marcan dataset.loading =
// '1', que su propio guard usa para ignorar clics posteriores. Ese estado solo se
// limpia en el .catch o tras el timeout del exito, y ninguno de los dos ocurre si
// el cliente navega al checkout: la pagina se congela tal cual.
//
// Safari en iOS y Chrome en Android restauran la pagina desde el bfcache al dar
// "atras", con el DOM y el JS exactamente como quedaron. El boton reaparece
// diciendo "Cargando checkout..." y sin aceptar toques, asi que quien vuelve
// para agregar algo mas ya no puede pagar. Ninguna de las paginas manda
// `Cache-Control: no-store`, o sea que si son elegibles para bfcache.
//
// La etiqueta original se captura en fase de captura, antes de que los handlers
// la pisen, y se restaura solo cuando la pagina viene del bfcache (`persisted`).
// En una carga normal este bloque no hace nada.
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action], #en-cart-checkout-btn, [data-ac-fixed-checkout]');
  if (btn && btn.dataset.enLabel === undefined) btn.dataset.enLabel = leerEtiquetaBoton(btn);
}, true);

window.addEventListener('pageshow', function(e) {
  if (!e.persisted) return;
  document.querySelectorAll('[data-en-label]').forEach(function(btn) {
    escribirEtiquetaBoton(btn, btn.dataset.enLabel);
    btn.style.opacity = '';
    btn.style.pointerEvents = '';
    delete btn.dataset.loading;
  });
});
}
